import { FC } from 'react';

import CapitalIncreaseModalHeader from './components/CapitalIncreaseModalHeader';
import CapitalIncreaseModalBody from './components/CapitalIncreaseModalBody';
import CapitalIncreaseModalFooter from './components/CapitalIncreaseModalFooter';
import { useCapitalIncreaseModal } from './context/CapitalIncreaseModalContext';
import CustomLoading from '../../CustomLoading';

const CapitalIncreaseModal: FC = () => {
  const { data } = useCapitalIncreaseModal();

  return (
    <>
      <CapitalIncreaseModalHeader />
      <CapitalIncreaseModalBody />
      <CapitalIncreaseModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default CapitalIncreaseModal;
